import Box from "@mui/material/Box";

import Image from "../image";
import { ASSETS_API, ASSETS_API_PREFIX } from "config-global";

// ----------------------------------------------------------------------

type Props = {
  imgUrl?: string;
  type?: string;
};

export default function SingleFilePreview({ imgUrl = "", type }: Props) {
  console.log("type ", type, " im ", imgUrl);

  return (
    <Box
      sx={{
        p: 1,
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        position: "absolute",
      }}
    >
      {type === "VIDEO" ? (
        // <iframe
        //   src={`https://iframe.mediadelivery.net/embed/160614/${imgUrl}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`}
        //   loading="lazy"
        //   style={{
        //     position: "absolute",
        //     top: 0,
        //     height: "100%",
        //     width: "100%",
        //     padding: 8,
        //     borderRadius: 24,
        //   }}
        //   allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        //   allowFullScreen
        // ></iframe>
        <video
          controls
          src={imgUrl}
          style={{
            maxWidth: "100%",
            height: "100%",
            width: "100%",
            borderRadius: 8,
          }}
        />
      ) : (
        <Image
          alt="file preview"
          src={imgUrl}
          sx={{
            width: 1,
            height: 1,
            borderRadius: 1,
          }}
        />
      )}
    </Box>
  );
}
